import { bdayPost, bdayGet } from 'services/utils';

const baseApi = '/api/1';

export const getVersion = () => {
  return bdayGet(`${baseApi}/version`);
}

export const getGlobalInfo = () => {
  return bdayGet(`${baseApi}/settings`);
}

export const getCountries = () => {
  return bdayGet(`${baseApi}/countries`);
}

export const getTimezones = (countryId) => {
  return bdayGet(`${baseApi}/timezones?countryId=${countryId}`);
}

export const getNames = () => {
  return bdayGet(`${baseApi}/names`);
}

export const getEmailProviders = () => {
  return bdayGet(`${baseApi}/email_providers`);
}

export const createCoupon = (payload) => {
  return bdayPost(`${baseApi}/coupon`, payload);
}

export const sendReactError = (data) => {
  return bdayPost(`${baseApi}/debug`, data);
}

export const postMetric = (payload) => {
  return bdayPost(`${baseApi}/metric`, payload);
}
